import { Link } from 'react-router-dom';
import { categories, zones } from '@/mocks/categories';

const zoneImageUrl = (slug: string): string => {
  if (slug === 'zone-jp') {
    return 'https://readdy.ai/api/search-image?query=Serene%20Japanese%20temple%20garden%20with%20cherry%20blossoms%2C%20warm%20golden%20light%2C%20traditional%20wooden%20architecture%2C%20soft%20focus%2C%20peaceful%20atmosphere%2C%20elegant%20composition&width=800&height=500&seq=zone-jp-bg&orientation=landscape';
  }
  return 'https://readdy.ai/api/search-image?query=Modern%20Korean%20traditional%20hanok%20village%20at%20sunset%2C%20warm%20terracotta%20tones%2C%20tiled%20roofs%2C%20cultural%20heritage%2C%20soft%20golden%20light%2C%20serene%20mood&width=800&height=500&seq=zone-kr-bg&orientation=landscape';
};

export default function CategoryNav() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            日韩双区 · 精准学习
          </h2>
          <p className="text-foreground-600 max-w-2xl mx-auto text-base">
            日本区与韩国区两大学习专区，五大课程分类，
            为不同学习目标的你提供最精准的课程匹配
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12">
          {zones.map((zone, idx) => (
            <Link
              key={zone.id}
              to={`/category/${zone.slug}`}
              className={`animate-fade-in-up stagger-${idx + 1} group relative overflow-hidden rounded-xl p-8 md:p-10 transition-all duration-300 hover:scale-[1.02]`}
            >
              <div className="absolute inset-0">
                <img
                  src={zoneImageUrl(zone.slug)}
                  alt=""
                  className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                />
                <div className={`absolute inset-0 ${
                  zone.slug === 'zone-jp'
                    ? 'bg-gradient-to-r from-red-900/70 to-red-900/30'
                    : 'bg-gradient-to-r from-amber-900/70 to-amber-900/30'
                }`}></div>
              </div>

              <div className="relative z-10">
                <span className="inline-block px-3 py-1 rounded-full bg-background-50/20 backdrop-blur-sm text-background-50 text-xs font-medium mb-4">
                  {zone.slug === 'zone-jp' ? '一区' : '二区'}
                </span>
                <h3 className="text-2xl md:text-3xl font-heading font-bold text-background-50 mb-3">
                  {zone.label}
                </h3>
                <p className="text-background-50/80 text-sm max-w-md">
                  {zone.description}
                </p>
                <span className="inline-flex items-center gap-1 mt-6 text-sm font-medium text-accent-400 group-hover:gap-2 transition-all duration-300">
                  查看课程 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group p-5 rounded-xl bg-background-100 hover:bg-primary-100/50 transition-all duration-300 text-center"
            >
              <div className="w-12 h-12 mx-auto mb-3 rounded-xl bg-primary-100 flex items-center justify-center group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2">
                {cat.description}
              </p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}